export default __webpack_public_path__ + "static/media/pedro.d10740e6.png";